export default __webpack_public_path__ + "static/device-desktop-8ebf8dba324dacb189ce3489f7172a9d.png";